import { UseFormReturn, Controller } from "react-hook-form";
import { Form } from "@/components/ui/form";
import { SectionDivider } from "./section-divider";
import { PermissionRow } from "./permission-row";
import { PermissionsFormData, PermissionLevelType } from "@/pages/configuracoes/schemas";
import { SettingsFooterActions } from "./settings-footer-actions";

interface PermissoesTabProps {
  form: UseFormReturn<PermissionsFormData>;
  onSave: () => void;
  onCancel: () => void;
  isSaving?: boolean;
}

export function PermissoesTab({ form, onSave, onCancel, isSaving }: PermissoesTabProps) {
  return (
    <div className="bg-[#15203c] rounded-lg p-4 flex flex-col gap-5">
      {/* Title and Description */}
      <div className="flex flex-col gap-0.5 leading-normal">
        <h2 className="font-['Plus_Jakarta_Sans'] font-bold text-xl text-white">
          Permissões
        </h2>
        <p className="font-['Plus_Jakarta_Sans'] font-normal text-xs text-[#d1d1d1]">
          Ajuste, altere e libere permissões no sistema
        </p>
      </div>

      {/* Permissions Section */}
      <Form {...form}>
        <div className="flex flex-col gap-5">
          {/* Section Divider */}
          <SectionDivider title="CADASTROS" />

          {/* Two Column Grid */}
          <div className="flex gap-4 items-start w-full">
            {/* Left Column */}
            <div className="flex flex-col gap-4 w-[721px]">
              <Controller
                name="registerNewMembers1"
                control={form.control}
                render={({ field }) => (
                  <PermissionRow
                    title="Cadastrar novos membros"
                    value={field.value as PermissionLevelType}
                    onChange={field.onChange}
                    name="registerNewMembers1"
                  />
                )}
              />

              <Controller
                name="registerNewMembers2"
                control={form.control}
                render={({ field }) => (
                  <PermissionRow
                    title="Cadastrar novos membros"
                    value={field.value as PermissionLevelType}
                    onChange={field.onChange}
                    name="registerNewMembers2"
                  />
                )}
              />

              <Controller
                name="registerNewMembers3"
                control={form.control}
                render={({ field }) => (
                  <PermissionRow
                    title="Cadastrar novos membros"
                    value={field.value as PermissionLevelType}
                    onChange={field.onChange}
                    name="registerNewMembers3"
                  />
                )}
              />

              <Controller
                name="registerNewMembers4"
                control={form.control}
                render={({ field }) => (
                  <PermissionRow
                    title="Cadastrar novos membros"
                    value={field.value as PermissionLevelType}
                    onChange={field.onChange}
                    name="registerNewMembers4"
                  />
                )}
              />
            </div>

            {/* Right Column */}
            <div className="flex flex-col gap-4 w-[721px]">
              <Controller
                name="registerNewMembers5"
                control={form.control}
                render={({ field }) => (
                  <PermissionRow
                    title="Cadastrar novos membros"
                    value={field.value as PermissionLevelType}
                    onChange={field.onChange}
                    name="registerNewMembers5"
                  />
                )}
              />

              <Controller
                name="registerNewMembers6"
                control={form.control}
                render={({ field }) => (
                  <PermissionRow
                    title="Cadastrar novos membros"
                    value={field.value as PermissionLevelType}
                    onChange={field.onChange}
                    name="registerNewMembers6"
                  />
                )}
              />

              <Controller
                name="registerNewMembers7"
                control={form.control}
                render={({ field }) => (
                  <PermissionRow
                    title="Cadastrar novos membros"
                    value={field.value as PermissionLevelType}
                    onChange={field.onChange}
                    name="registerNewMembers7"
                  />
                )}
              />

              <Controller
                name="registerNewMembers8"
                control={form.control}
                render={({ field }) => (
                  <PermissionRow
                    title="Cadastrar novos membros"
                    value={field.value as PermissionLevelType}
                    onChange={field.onChange}
                    name="registerNewMembers8"
                  />
                )}
              />
            </div>
          </div>
        </div>
      </Form>
      <SettingsFooterActions onSave={onSave} onCancel={onCancel} isSaving={isSaving} />
    </div>
  );
}

PermissoesTab.displayName = "PermissoesTab";
